import { render } from "./BottlesList.vue?vue&type=template&id=0562d860&scoped=true"
import script from "./BottlesList.vue?vue&type=script&lang=js"
export * from "./BottlesList.vue?vue&type=script&lang=js"

import "./BottlesList.vue?vue&type=style&index=0&id=0562d860&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0562d860"]])

export default __exports__

/* vue-cli-plugin-import-components */

import DropdownButton from "@/components/DropdownButton.vue";
import RefundModal from "@/components/neue/RefundModal.vue";
import TableContainer from "@/components/TableContainer.vue";
import TablePagination from "@/components/TablePagination.vue";
script.components = Object.assign({}, { DropdownButton, RefundModal, TableContainer, TablePagination }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { DropdownButton, RefundModal, TableContainer, TablePagination }, script.__o.components);}